import { EVENTS } from '../constants/webSocketConsts/events';
import { handleSignOut } from '../utils/UserUtils';
import { PortalConfig } from '../context';
import {
  addInternalUsers,
  modifyInternalUsers,
  removeInternalUsers,
} from '../store/users/actions';

const InternalUserHandler = (
  event: string,
  items: Array<any>,
  portalConfig: PortalConfig,
  userID: string,
) => {
  switch (event) {
    case EVENTS.INSERT:
      return addInternalUsers(items);
    case EVENTS.MODIFY:
      return modifyInternalUsers(items);
    case EVENTS.REMOVE:
      if (items.map(item => item.id).includes(userID)) {
        handleSignOut(portalConfig, false);
      }
      return removeInternalUsers(items);
      break;
    default:
      break;
  }
  return null;
};

export default InternalUserHandler;
